import React, { useState } from "react";
import {
  Box,
  PaginationItem,
  TableBody,
  TableCell,
  TableHead,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { TableContainer } from "@mui/material";
import { Table } from "@mui/material";
import { TableRow } from "@mui/material";

import Paper from "@mui/material/Paper";
import { Pagination } from "@mui/material";
// import { getTableTheme } from "../../utils/theme";

const ResuableTable = ({
  userName,
  title,
  data,
  tableHeader,
  renderCell,
  setSortLabelType,
  setToggleSort,
  handleUserDetails,
  page,
  setPage,
}) => {
  const [sortOrder, setSortOrder] = useState("asc"); // Sorting order: "asc" or "desc"
  const [sortColumn, setSortColumn] = useState(""); // Column to sort

  // Sorting function
  const handleSort = (column) => {
    if (column !== "action") {
      const isAsc = sortColumn === column && sortOrder === "asc";
      setSortOrder(isAsc ? "desc" : "asc");
      setSortColumn(column);
    }
  };

  // Sort rows based on selected column and order
  const sortedRows = [...data].sort((a, b) => {
    const valueA = a[sortColumn];
    const valueB = b[sortColumn];
    if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
    if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  // const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const options = {
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
    search: true,
    download: true,
    print: false,
    viewColumns: true,
    pagination: false,
  };

  const paginatedData = sortedRows?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleUserSelected = (user) => {
    handleUserDetails(user);
  };

  return (
    <div
      style={{
        // border: "1px solid #C1C1C2",
        // borderRadius: "5px",
        overflow: "hidden",
      }}
    >
      <Box>
        <TableContainer
          sx={{
            // height: "400px",
            border: "1px solid #C1C1C2",
            borderRadius: "5px",
            minHeight: "300px",
          }}
        >
          <Table>
            {/* Table Header */}
            <TableHead
              className="table-header"
              sx={{ backgroundColor: "#93CFEC33" }}
            >
              <TableRow
                className="table-header-row"
                sx={{ backgroundColor: "#93CFEC33" }}
              >
                {tableHeader.map((item) => {
                  return (
                    <React.Fragment>
                      <TableCell sx={{ py: "8px" }}>
                        <Box sx={{ display: "flex", cursor: "pointer" }}>
                          <TableSortLabel
                            active={sortColumn === item.field}
                            direction={sortOrder}
                            onClick={() => handleSort(item.field)}
                          >
                            <Typography fontWeight={"bold"}>
                              {item.label}
                            </Typography>
                          </TableSortLabel>
                        </Box>
                      </TableCell>
                    </React.Fragment>
                  );
                })}
              </TableRow>
            </TableHead>

            {/* Table Body */}
            <TableBody>
              {paginatedData.length > 0 ? (
                paginatedData.map((row, i) => {
                  return (
                    <TableRow>
                      {tableHeader.map((column, i) => {
                        return (
                          <TableCell
                            sx={{
                              py: "8px",
                              textTransform:
                                column.field === "locationName" ||
                                column.field === "name"
                                  ? "capitalize"
                                  : "none",
                              fontWeight:
                                column.field === "name" ? "700" : "normal",
                            }}
                            // onClick={() => handleUserSelected(row)}
                          >
                            {renderCell
                              ? renderCell(row, column, i)
                              : row[column.field]}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={tableHeader.length} align="center">
                    No data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <MUIDataTable
        // title={`${title}(${data?.length})`}
        data={paginatedData}
        columns={tableHeader}
        options={options}
      /> */}
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        m={2}
      >
        <Box sx={{ color: "#5e5e5e" }}>
          {`${page * rowsPerPage + 1}-${Math.min(
            (page + 1) * rowsPerPage,
            data.length
          )} of ${data?.length}`}
        </Box>
        <Box>
          <Pagination
            variant="outlined"
            shape="rounded"
            component="div"
            count={Math.ceil(data.length / rowsPerPage)} // Total number of pages
            page={page + 1} // MUI Pagination is 1-based, so increment by 1
            onChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            // rowsPerPageOptions={[5, 10, 15, 20]} // Rows per page options
            renderItem={(item) => (
              <PaginationItem
                {...item}
                sx={{
                  background: item.selected ? "#004D72  !important" : "",
                  color: item.selected ? "#fff !important" : "",
                }}
              />
            )}
          />
        </Box>
      </Box>
    </div>
  );
};

export default ResuableTable;
